import React from 'react';
import { Row, Col, Typography } from 'antd';
import styled from 'styled-components';
import { useResponsive } from '../../../../hooks/useResponsive';

const { Title } = Typography;

interface PageContainerProps {
  title?: string | React.ReactNode;
  subtitle?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  headerContent?: React.ReactNode;
  titleStats?: React.ReactNode;
}

const StyledPageContainer = styled.div`
  padding: 0;
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

const PageHeader = styled.div`
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  
  @media (max-width: 768px) {
    .header-layout {
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 16px;
      
      .title-section {
        min-width: auto !important;
      }
      
      .stats-section {
        margin: 0 !important;
        justify-content: flex-start !important;
        width: 100%;
      }
      
      .actions-section {
        min-width: auto !important;
        width: 100%;
        justify-content: flex-start !important;
      }
    }
  }
`;

const PageTitle = styled(Title)`
  &.ant-typography {
    margin-bottom: 8px;
    font-size: 28px;
    font-weight: 700;
    color: #1a1a2e;
    line-height: 1.2;
    
    @media (max-width: 768px) {
      font-size: 24px;
    }
  }
`;

const PageSubtitle = styled(Typography.Text)`
  font-size: 16px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.5;
  margin-top: 4px;
  display: block;
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-start;
    margin-top: 16px;
  }
`;

const PageContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const PageContainer: React.FC<PageContainerProps> = ({
  title,
  subtitle,
  children,
  actions,
  headerContent,
  titleStats
}) => {
  const { isDesktop } = useResponsive();

  return (
    <StyledPageContainer>
      {(title || subtitle || actions) && (
        <PageHeader>
          <div className="header-layout" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%' }}>
            <div className="title-section" style={{ flex: '0 0 auto', minWidth: '200px' }}>
              {title && (
                typeof title === 'string' ? (
                  <PageTitle level={2}>{title}</PageTitle>
                ) : (
                  <PageTitle level={2} style={{ margin: 0 }}>{title}</PageTitle>
                )
              )}
              {subtitle && <PageSubtitle>{subtitle}</PageSubtitle>}
            </div>
            
            {titleStats && (
              <div className="stats-section" style={{ flex: '1 1 auto', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 24px' }}>
                {titleStats}
              </div>
            )}
            
            {actions && (
              <div className="actions-section" style={{ flex: '0 0 auto', minWidth: '200px', display: 'flex', justifyContent: 'flex-end' }}>
                <HeaderActions>{actions}</HeaderActions>
              </div>
            )}
          </div>
          {headerContent && (
            <div style={{ marginTop: '16px' }}>
              {headerContent}
            </div>
          )}
        </PageHeader>
      )}
      <PageContent>{children}</PageContent>
    </StyledPageContainer>
  );
};




